import { render, staticRenderFns } from "./CompensationPointsAdd.vue?vue&type=template&id=1db2e29d&scoped=true&"
import script from "./CompensationPointsAdd.vue?vue&type=script&lang=js&"
export * from "./CompensationPointsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2e29d",
  null
  
)

export default component.exports